export default {
    methods: {
        hasPerm(perm) {
            // 使用 main.js 中全局缓存的权限检查方法，避免每次 JSON.parse
            if (this.$hasPerm) {
                return this.$hasPerm(perm)
            }
            // 兆底：如果全局方法未初始化
            try {
                const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
                if (permissions.includes('*:*:*')) return true
                if (Array.isArray(perm)) {
                    return perm.some(p => permissions.includes(p))
                }
                return permissions.includes(perm)
            } catch {
                return false
            }
        },

        getUserInfo() {
            try {
                return JSON.parse(localStorage.getItem('userInfo') || '{}')
            } catch {
                return {}
            }
        },

        getToken() {
            return localStorage.getItem('token')
        }
    }
}

//权限调用方法
// <template>
//     <el-button v-if="hasPerm('system:permission:save')" @click="handleAdd">新增</el-button>
// </template>
//
// <script>
//     export default {
//     methods: {
//     handleAdd() {
//     if (!this.hasPerm('system:permission:save')) {
//     this.$message.warning('无权限')
//     return
// }
//     // 业务逻辑
// }
// }
// }
// </script>